import { getVersion, replaceAllComplex, umcodeURL } from './mol_function';
import {
  SearchPagebrowserUrlToReactUrl,
  SearchPageReactUrlToApiUrl,
  SearchPageReactUrlToBrowserUrl,
} from './Page/components/pages/searchPage';
import { pushError } from './pushError';

function browserUrlToReactUrlIntern(pathname, search, disableCheck) {
  let result = '';
  if ((search == null || search == '') && pathname.indexOf('?') > 0) {
    let split = pathname.indexOf('?');
    search = pathname.substr(split);
    pathname = pathname.substr(0, split);
  }

  if (search != null && search.length >= 1 && search[0] == '?')
    search = search.substr(1);

  if (pathname.startsWith('https://www.moluna.de')) {
    pathname = pathname.substr('https://www.moluna.de'.length);
  }

  if (pathname.length > 1 && pathname[0] == '/') pathname = pathname.substr(1);

  if (
    pathname == 'search_page/' ||
    pathname.endsWith('/s/') ||
    pathname.endsWith('/k/') ||
    (pathname == 'index.php' &&
      search.indexOf('main_page=advanced_search_result') != -1)
  ) {
    result = SearchPagebrowserUrlToReactUrl(pathname, search);
  } else if (
    pathname == 'index.php' &&
    search.indexOf('main_page=advanced_search_result') != -1
  ) {
    //TODO: Move This Sction
    let parts = search.split('&');

    let otherParts = [];
    let fqZZZParts = [];

    let keyword = '*';

    for (let i = 0; i < parts.length; i++) {
      let kvp = parts[i].split('=');
      if (kvp[0].startsWith('fqZZZ')) {
        let value2 = replaceAllComplex(kvp[1], [{ s: '%26', r: '_-_' }]);
        fqZZZParts.push(kvp[0] + '=' + value2);
      } else if (kvp[0] == 'keyword') {
        let tmp = kvp[1];
        tmp = replaceAllComplex(tmp, [
          { s: '%2C', r: ',' },
          { s: '%2F', r: '___' },
        ]);
        tmp = decodeURI(tmp);
        keyword = tmp;
      } else if (parts[i] == 'main_page=advanced_search_result') {
        //skip
      } else {
        otherParts.push(parts[i]);
      }
    }

    fqZZZParts.sort();
    otherParts.sort();

    let paramsArray = fqZZZParts;

    if (keyword != '*') {
      paramsArray.push('keyword=' + encodeURI(keyword));
    }

    paramsArray = paramsArray.concat(otherParts);

    let url = '/search_page/?';

    url = url + paramsArray.join('&');

    result = url;
  } else if (pathname.startsWith('product_info/')) {
    if (search == '') return '/' + pathname;
    else result = '/' + pathname + '?' + search;
  } else if (pathname == 'shopping_cart/') {
    result = '/shopping_cart/';
  } else if (pathname == 'container/') {
    result = '/container/';
  } else if (pathname == 'check') {
    result = '/check';
  } else if (
    pathname.toLowerCase().startsWith('buch/') ||
    pathname.toLowerCase().startsWith('musik/') ||
    pathname.toLowerCase().startsWith('film/') ||
    pathname.toLowerCase().startsWith('spielware/') ||
    pathname.toLowerCase().startsWith('games/') ||
    pathname.toLowerCase().startsWith('software/') ||
    pathname.toLowerCase().startsWith('kalender/') ||
    pathname.toLowerCase().startsWith('lifestyle/') ||
    pathname.toLowerCase().startsWith('schreibwaren/') ||
    pathname.toLowerCase().startsWith('noten/')
  ) {
    let indexKat = pathname.indexOf('/');
    let link1 = pathname.substr(indexKat + 1);
    let indexMinus = link1.indexOf('-');
    let productId = link1.substr(0, indexMinus);
    result = '/product_info/' + productId;
  } else if (pathname == '/') {
    result = '/';
  }

  let version = getVersion();

  if (version == 'develop' && disableCheck == false) {
    let rollbackAdresse = reactUrlToBrowserUrlIntern(result, null, null, true);
    if (rollbackAdresse.length > 1 && rollbackAdresse[0] == '/')
      rollbackAdresse = rollbackAdresse.substring(1);

    let inputFull = pathname;
    if (search != null && search != '' && search != 'keyword=*') {
      inputFull += '?' + search;
    }

    inputFull = replaceAllComplex(inputFull, [{ s: ' ', r: '%20' }]);
    /*
    if (rollbackAdresse != '' && rollbackAdresse != inputFull) {
      debugger;
      let result2 = browserUrlToReactUrlIntern(pathname, search, true);
      let rollbackAdresse2 = reactUrlToBrowserUrlIntern(
        result2,
        null,
        null,
        true,
      );
    }
    */
  }

  return result;
}

const UTF8_CODE_ALLOW_CHARS = stringToCharArray(
  '0123456789' +
    'abcdefghijklmnopqrstuvwxyz' +
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
    "/_?&=-%.#*!'()",
);

function stringToCharArray(input: string) {
  let result = [];
  for (let i = 0; i < input.length; i++) {
    result.push(input[i]);
  }
  return result;
}

export function browserUrlToReactUrl(pathname: string, search: string) {
  let version = getVersion();

  if (version == 'develop') {
    for (let i = 0; i < pathname.length; i++) {
      if (UTF8_CODE_ALLOW_CHARS.indexOf(pathname[i]) === -1)
        if (pathname[i] != ',' && pathname[i] != '+' && pathname[i] != ' '){
          //debugger;
        }
    }
    /*
    for (let j = 0; search != null && j < search.length; j++) {
      if (UTF8_CODE_ALLOW_CHARS.indexOf(search[j]) === -1)
        if (search[j] != ',' && search[j] != '+') debugger;
    }
*/
  }

  let response = browserUrlToReactUrlIntern(pathname, search, false);
  return response;
}

export function reactUrlToApiUrl(pathname: string) {
  let version = getVersion();

  if (version == 'develop') {
    for (let i = 0; i < pathname.length; i++) {
      if (UTF8_CODE_ALLOW_CHARS.indexOf(pathname[i]) === -1) debugger;
    }
  }

  if (pathname.startsWith('/search_page/')) {
    return SearchPageReactUrlToApiUrl(pathname);
  } else if (pathname.startsWith('/product_info/')) {
    let productID = pathname.substring(14);
    return (
      '/index.php?frame=api&main_page=product_info&products_id=' + productID
    );
  } else if (pathname == '/shopping_cart/') {
    return '/index.php?frame=api&main_page=shopping_cart';
  } else if (pathname == '/') {
    return '/index.php?frame=api&main_page=start';
  } else if (pathname == '/container/') {
    return '/container/';
  } else if (pathname == '/check') {
    return '/index.php?frame=api&main_page=check';
  } else throw new Error('Method path not implemented yet.');
}

function reactUrlToBrowserUrlIntern(
  pathname: string,
  search: string | null,
  apidata: any,
  disableCheck: boolean,
) {
  if (search == null && pathname.indexOf('?') > 0) {
    search = pathname.substr(pathname.indexOf('?'));
    pathname = pathname.substr(0, pathname.indexOf('?'));
  }

  let result = '';

  if (pathname == '/search_page/') {
    result = SearchPageReactUrlToBrowserUrl(pathname, search);
  } else if (pathname.startsWith('/product_info/') && apidata != null) {
    result = apidata.body.linkShort;
  } else if (pathname.startsWith('/product_info/') && apidata == null) {
    result = '';
  } else if (pathname == '/shopping_cart/') {
    result = '/index.php?main_page=shopping_cart';
  } else if (pathname == '/') {
    result = '/';
  } else if (pathname == '') {
    result = '';
  } else if (pathname == '/container/' && apidata != null) {
    result = apidata.body.urlPath;
  } else if (pathname == '/container/' && apidata == null) {
    result = '';
  } else {
    debugger;
  }

  let version = getVersion();

  if (version == 'develop' && disableCheck == false) {
    let rollbackAdresse = browserUrlToReactUrlIntern(result, null, true);
    let inputFull = pathname;
    if (search != null && search != '') {
      if (search[0] != '?') inputFull += '?';
      inputFull += search;
    }
    rollbackAdresse = replaceAllComplex(rollbackAdresse, [
      { s: ' ', r: '%20' },
    ]);

    if (rollbackAdresse != '' && rollbackAdresse != inputFull) {
      //debugger;
      let result2 = reactUrlToBrowserUrlIntern(pathname, search, null, true);
      rollbackAdresse = browserUrlToReactUrlIntern(result2, null, true);
    }
  }
  return result;
}

export function reactUrlToBrowserUrl(
  pathname: string,
  search: string,
  apidata: any,
) {
  let response = reactUrlToBrowserUrlIntern(pathname, search, apidata, false);
  return response;
}
